import { useEffect } from 'react';
import { partnerSettingsStore } from '@bg-shared/business/PartnerSettings';
import { useModalsManager } from '@bg-shared/contexts/ModalsManager';
import { webAPIIntegration } from '../webAPIIntegration';
import { IBasicWebIntegration } from '../interfaces';

export const useWebAPIIntegration = () => {
    const modalManager = useModalsManager();

    useEffect(() => {
        webAPIIntegration<IBasicWebIntegration>(partnerSettingsStore.webIntegrationType, (api) => {
            api.registerModalsManager(modalManager);
        });

        const onUnload = () => {
            webAPIIntegration(partnerSettingsStore.webIntegrationType, (api) => {
                api.exitGame();
            });
        };

        window.addEventListener('beforeunload', onUnload);

        return () => {
            window.removeEventListener('beforeunload', onUnload);
        };
    }, []);
};
